import { render, staticRenderFns } from "./my_team.vue?vue&type=template&id=6a428ebf&"
import script from "./my_team.vue?vue&type=script&lang=js&"
export * from "./my_team.vue?vue&type=script&lang=js&"
import style0 from "./my_team.vue?vue&type=style&index=0&id=6a428ebf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports